module.exports = __webpack_public_path__ + "static/img/WechatIMG117.a4f69728.jpeg";